export default __webpack_public_path__ + "static/media/workorder.2c2e488e.svg";